export const money = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: 2 }).format(n || 0);

export const fmtDate = (d) => {
  if (!d) return "";
  const dt = new Date(String(d).slice(0, 10) + "T12:00:00");
  return dt.toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric" });
};

export const CATEGORIES = {
  haber: { label: "Haber", cls: "bg-[#D8F3DC] text-[#1B4332]" },
  taziye: { label: "Taziye", cls: "bg-slate-200 text-slate-700" },
  tebrik: { label: "Tebrik", cls: "bg-amber-100 text-amber-800" },
  kesinti: { label: "Elektrik / Su Kesintisi", cls: "bg-[#E07A5F]/15 text-[#B4492F]" },
  genel: { label: "Genel Duyuru", cls: "bg-sky-100 text-sky-800" },
};

export const SUBJECTS = {
  dilek: "Dilek / Öneri",
  sikayet: "Şikayet",
  ariza: "Arıza Bildirimi",
  diger: "Diğer",
  iletisim: "İletişim Formu",
};
